// ─── DESIGN SYSTEM — Blue Luxury ───────────────────────────────────────────────
export const B = {
  ink:        "#060E1E",
  navy:       "#0B1D3A",
  navyAlt:    "#0F2548",
  navyMid:    "#132D5C",
  royal:      "#1A4A8A",
  cobalt:     "#1D5CA8",
  azure:      "#2563EB",
  sky:        "#3B82F6",
  mist:       "#60A5FA",
  pale:       "#DBEAFE",
  ghost:      "#EFF6FF",
  white:      "#FFFFFF",
  dimBlue:    "#4A6FA5",
  faint:      "#8AAFD4",
  hairline:   "#1E3A6E",
  slate:      "#475569",
  slateLight: "#94A3B8",
  border:     "#BFDBFE",
  gold:       "#C9953C",
  goldLight:  "#E8C777",
  success:    "#22C55E",
};

// ─── ADMIN DESIGN TOKENS ───────────────────────────────────────────────────────
export const G = {
  bg:       "radial-gradient(ellipse at 20% 0%, #0F2548 0%, #060E1E 60%)",
  glass:    "rgba(11,29,58,0.65)",
  glassBrd: "rgba(255,255,255,0.06)",
  btnGrad:  "linear-gradient(135deg, #2563EB 0%, #1A4A8A 100%)",
  btnShadow:"0 4px 14px rgba(37,99,235,0.35)",
  sidebar:  "rgba(6,14,30,0.92)",
};

export const ADMIN_API      = (process.env.REACT_APP_ADMIN_API_URL      || "") + "/admin";
export const PORTFOLIO_API  = (process.env.REACT_APP_PORTFOLIO_API_URL  || "") + "/portfolio";

export const ADMIN_MODULES = [
  { id: "leads",     label: "Leads"          },
  { id: "portfolio", label: "Portfolio"      },
  { id: "chatbot",   label: "ChatBot"        },
  { id: "users",     label: "Users"          },
  { id: "logs",      label: "Login Logs"     },
  { id: "kb",        label: "Knowledge Base" },
  { id: "audit",     label: "Audit Trail"   },
];

export const adminInput = (extra = {}) => ({
  width: "100%", padding: "10px 14px", borderRadius: 10,
  border: "1px solid rgba(255,255,255,0.1)", background: "rgba(6,14,30,0.6)",
  color: "#fff", fontFamily: "'Space Grotesk', sans-serif",
  fontSize: 13, outline: "none", boxSizing: "border-box", ...extra,
});

export const LEAD_STATUSES = ["New","Contacted","In Progress","Converted","Not Interested","No Response"];
export const LEAD_STATUS_COLORS = {
  "New":            { bg: "rgba(37,99,235,0.13)",  text: "#93C5FD", border: "rgba(37,99,235,0.3)"  },
  "Contacted":      { bg: "rgba(124,58,237,0.13)", text: "#C4B5FD", border: "rgba(124,58,237,0.3)" },
  "In Progress":    { bg: "rgba(217,119,6,0.13)",  text: "#FCD34D", border: "rgba(217,119,6,0.3)"  },
  "Converted":      { bg: "rgba(5,150,105,0.13)",  text: "#34D399", border: "rgba(5,150,105,0.3)"  },
  "Not Interested": { bg: "rgba(220,38,38,0.13)",  text: "#f87171", border: "rgba(220,38,38,0.3)"  },
  "No Response":    { bg: "rgba(100,116,139,0.13)",text: "#94A3B8", border: "rgba(100,116,139,0.3)" },
};

// Sidebar SVG icons
export const IcoKB    = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>;
export const IcoLeads = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
export const IcoUsers = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4"/><path d="M20 21a8 8 0 1 0-16 0"/><line x1="17" y1="14" x2="23" y2="14"/><line x1="20" y1="11" x2="20" y2="17"/></svg>;
export const IcoLogs    = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>;
export const IcoChatBot = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/><path d="M13 8l-2 4h3l-2 4" strokeWidth="1.4"/></svg>;
export const IcoAudit     = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>;
export const IcoPortfolio = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>;
